'use strict';
var ACC;
ACC.mobilemenu = {
    _autoload: [
        'cacheElements',
        'bindMobileMenuEvents',
        'bindMobileSearchAutocomplete',
        ['init', $('[data-header-sub]').length] // Not on checkout
    ],

    // Add your constants here.
    _constants: {
        CLASS_HAS_CHILDREN: 'hasChildSection',
        CLASS_SEARCH_ACTIVE: 'searchResultsOpen',
        CLASS_FONT_BOLD: 'u-font-bold',
        CLASS_ICON_DOWN: 'icon-down-open-big',
        CLASS_ICON_UP: 'icon-up-open-big',
        DATA_CATEGORY_TITLE: 'data-category',
        DATA_CATEGORY_ID: 'data-categoryid',
        DATA_CATEGORY_LINK: 'data-panel-link',
        DATA_CATEGORY_PARENT: 'data-categoryparent',
        DATA_CATEGORY_PARENT_ID: 'data-categoryparentid',
        DATA_CATEGORY_PATH: 'data-categorypath',
        DATA_CATEGORY_TEXT_COLOR: 'data-categorymobiletextcolor',
        DATA_CATEGORY_BACKGROUND_COLOR: 'data-categorymobilebackgroundcolor',
        NUMBER_LIST_LEVELS: 3,
        SELECTOR_ARROW_ICON: '> .icon-container .icon',
        SELECTOR_LEVEL_0: '.level_0',
        SELECTOR_LEVEL_1: '.level_1',
        SELECTOR_LEVEL_2: '.level_2',
        SELECTOR_LEVEL_1_NAV_CONTAINER: '.level-1-navigation-container',
        SELECTOR_LEVEL_2_NAV_CONTAINER: '.level-2-navigation-container',
        SELECTOR_MAIN_NAV: '#facetScroll',
        SELECTOR_MENU_BUTTON: '#mobileMenuActivator',
        SELECTOR_MENU_CLOSE_BUTTON: '#mobileCloseWrapper',
        SELECTOR_SEARCH_CONTAINER: '#mobileSearch',
        SELECTOR_SEARCH_AUTOCOMPLETE: '#mobileSearchAutocomplete',
        SELECTOR_TREE_SUB_NAVIGATION_CONTAINER: '.tree-sub-navigation-container'
    },

    // Populate on the fly for cached elements such as multiple use jQuery look-ups.
    _cache: {
        $navLists: $(), // Populated in createNavList()
        $panels: $(), // Stores the visual panels
        text: {}, // Populated on the fly to hold JSP text from properties.
    },

    // Stores the user section actions.
    _journey: new Array(),

    // Grab anything to cache immediately if always in use.
    cacheElements: function() {
        var MM = ACC.mobilemenu;
        var cache = MM._cache;
        var c = MM._constants;
        var SP = ACC.sidepanel;
        var SP_s = SP._state;

        cache.$body = $(document.body);
        cache.$mainNav = $(c.SELECTOR_MAIN_NAV);
        cache.$menuButton = $(c.SELECTOR_MENU_BUTTON);
        cache.$closeMenuButton = $(c.SELECTOR_MENU_CLOSE_BUTTON);
        cache.$search = $(c.SELECTOR_SEARCH_CONTAINER);
        cache.$autocomplete = $(c.SELECTOR_SEARCH_AUTOCOMPLETE);

        // These do not exist or aren't in useful form, so we'll create/clone them.
        if (!SP_s.IS_TREE_NAVIGATION) {
            cache.$navLists = MM.createNavLists();
            cache.$panels = MM.createPanels();
        }
        cache.$component = SP.createComponent('mobilemenu');
        cache.$nav = $('<nav class="tree-navigation-wrapper" id="tree-navigation-wrapper" role="navigation"></nav>');
        cache.$nav.attr('aria-label', cache.$mainNav.attr('aria-label'));

        // First add any text detected in JSP in cache.text
        ACC.global.setDataElementText(cache.text, cache.$mainNav);
    },

    // Menu currently only three levels deep.
    // Find navigation <li> elements to clone and form new cleaned <ul> elements.
    createNavLists: function() {
        var MM = ACC.mobilemenu;
        var c = MM._constants;
        var $lists = $();

        for (var i=0; i<c.NUMBER_LIST_LEVELS; ++i) {
            $lists = $lists.add(MM.createLevelLists(String(i)));
        }

        return $lists;
    },

    // Creates list elements from nodes found in Mega Menu items.
    // @level (String) Points to Menu items with .level_X class (e.g. level_1).
    createLevelLists: function(level) {
        var MM = ACC.mobilemenu;
        var cache = MM._cache;
        var c = MM._constants;

        var $items = $(c['SELECTOR_LEVEL_' + level], cache.$mainNav);
        var $collection = $();
        var $ul, trackId;

        // Create clean HTML.
        // Note: initial id is undefined so will
        // always go into the IF condition on first item
        $items.each(function() {
            var $this = $(this);
            var id = $this.attr(c.DATA_CATEGORY_PARENT_ID);
            var name = $this.attr(c.DATA_CATEGORY_PARENT);
            var path = $this.attr(c.DATA_CATEGORY_PATH);

            if (id != trackId) {
                trackId = id;
                $ul = MM.createLevelList(id, name, path);
                $collection = $collection.add($ul);
            }
            $ul.append(MM.createLevelListItem(this));
        });

        return $collection;
    },

    // Create and return a new list
    // @id (String) Category UID
    // @name (String) Category name
    createLevelList: function(id, name, path){
        var MM = ACC.mobilemenu;
        var c = MM._constants;
        var $ul = $('<ul></ul>');

        $ul.attr(c.DATA_CATEGORY_ID, id);
        $ul.attr(c.DATA_CATEGORY_TITLE, name);
        $ul.attr(c.DATA_CATEGORY_PATH, path);

        return $ul;
    },

    // Creates a new, clean <li> from the one passed.
    // @node (HTML node) <li> found in Mega Menu.
    createLevelListItem: function(node) {
        var MM = ACC.mobilemenu;
        var c = MM._constants;
        var SP_c = ACC.sidepanel._constants;
        var $li = $('<li>');
        var hasChildSection = $(node).hasClass('has-sub');

        // If it has children then it navigates menu.
        // Otherwise, it should be a link to page.
        if (hasChildSection) {
            $li.addClass(c.CLASS_HAS_CHILDREN);
            $li.append('<span>' + node.getAttribute(c.DATA_CATEGORY_TITLE) + '</span>');
            $li.attr(SP_c.ATTRIBUTE_PANEL_TARGET, node.getAttribute(c.DATA_CATEGORY_ID));
        }
        else {
            $li.append($(node).find('> a').clone());
        }

        $li.attr(c.DATA_CATEGORY_LINK, node.getAttribute(c.DATA_CATEGORY_ID));
        $li.append('<span class="icon icon-right-open-mini" aria-hidden="true"></span>');

        return $li;
    },

    // Create / adjust elements ready to become panels.
    createPanels: function() {
        var MM = ACC.mobilemenu;
        var c = MM._constants;
        var cache = MM._cache;
        var SP = ACC.sidepanel;
        var $panels = $();

        cache.$navLists.each(function() {
            var $this = $(this);
            var id = $this.attr(c.DATA_CATEGORY_ID);
            var title = $this.attr(c.DATA_CATEGORY_TITLE);
            var path = $this.attr(c.DATA_CATEGORY_PATH);

            $panels = $panels.add(SP.createPanel($this, id, title, path));

            // Clean up.
            $this.removeAttr(c.DATA_CATEGORY_ID);
            $this.removeAttr(c.DATA_CATEGORY_TITLE);
            $this.removeAttr(c.DATA_CATEGORY_PATH);
        });

        return $panels;
    },

    // Set up main functionality
    init: function() {
        var MM = ACC.mobilemenu;
        var cache = MM._cache;
        var c = MM._constants;
        var SP = ACC.sidepanel;
        var SP_c = SP._constants;
        var SP_s = SP._state;
        var SP_cache = SP._cache;

        // Add new elements to DOM
        SP.setText(cache.$component, 'back', cache.text.back);
        SP.init(cache.$component, cache.$panels);

        // Make some mobile menu specific customisations.
        cache.$component.data(SP_c.DATA_CONTENT).append(cache.$search);
        cache.$component.data(SP_c.DATA_CONTENT).append(cache.$autocomplete);
        cache.$component.data(SP_c.DATA_CONTENT).append(cache.$nav);
        cache.$nav.before(cache.$component.data(SP_c.DATA_BACK));
        cache.$nav.append(cache.$component.data(SP_c.DATA_TITLE));
        cache.$nav.append(cache.$component.data(SP_c.DATA_PANELS).parent());

        // Checks if new component containing tree navigation exists.
        if (SP_s.IS_TREE_NAVIGATION) {
            var ariaLabels = SP && SP.hasOwnProperty('_aria_labels') ? SP._aria_labels : null;
            var departmentMenuAriaLabel = 'Shop by department';
            if (ariaLabels && ariaLabels.hasOwnProperty('SHOP_BY_DEPARTMENT')) {
                departmentMenuAriaLabel = ariaLabels.SHOP_BY_DEPARTMENT;
            }
            var $mobileListL0 = $(`<ul class="navigation-list" aria-label="${departmentMenuAriaLabel}"></ul>`);
            var $items = $(c.SELECTOR_LEVEL_0).clone();
            var $globalToolsNav = SP_cache.$globalToolsNav;

            $items.each(MM.createTreeNav);
            $mobileListL0.append($items);
            cache.$nav.append($mobileListL0);
            cache.$nav.append($globalToolsNav);
        }

        SP.bindComponentEvents();

        ACC.mobilemenu.ready = true;
        $(document).trigger('ACC.mobilemenu.ready');

        MM.applyMobileColors();
    },

    // Create navigation elements cloned from new tree navigation structure.
    createTreeNav: function() {
        var MM = ACC.mobilemenu;
        var c = MM._constants;
        var $this = $(this);
        var hasChildSection = $this.hasClass('has-sub');

        if (hasChildSection) {
            var $container = $this.find(c.SELECTOR_LEVEL_1_NAV_CONTAINER);
            var $arrow = $this.find(c.SELECTOR_ARROW_ICON);

            try {
                var id = $container.attr('id');
                // stripping special characters from component id
                const newId = id.replace(/[^A-Z0-9]/ig, "");
                var mobileId = `m-${newId}`;

            } catch(error) {
                console.log('Error removing special characters from id attibute', error);
                
            }

            $this.children('.main-navigation-item__expand-button').remove();
            $this.children('a').attr('role', 'button');
            $this.children('a').attr('aria-expanded', 'false');
            $this.children('a').attr('aria-controls', mobileId);
            $container.attr('id', mobileId);

            $this.children('a').on('click touch', function (e) {
                var target = $(e.target);
                var isSecondLevelNode = (target.closest(c.SELECTOR_LEVEL_2).length) ? true : false;

                if (!isSecondLevelNode) {
                    e.preventDefault();
                    e.stopPropagation();

                    if ($container.is(':hidden')) {
                        // Expand
                        $(this).attr('aria-expanded', 'true');
                        $arrow.removeClass(c.CLASS_ICON_DOWN).addClass(c.CLASS_ICON_UP);
                        $container.slideDown();
                        // Analytics
                        ACC.megamenu.attachMegaMenu_L0(e, 'expand');
                    } else {
                        // Collapse
                        $(this).attr('aria-expanded', 'false');
                        $arrow.removeClass(c.CLASS_ICON_UP).addClass(c.CLASS_ICON_DOWN);
                        $container.slideUp();
                        // Analytics
                        ACC.megamenu.attachMegaMenu_L0(e, 'collapse');
                    }
                }
            });

            $this.find(c.SELECTOR_LEVEL_1).each(MM.createTreeSubNav);

        }
        // else continue navigation as simple link
    },

    // Create navigation elements from nodes found in the new tree structure.
    createTreeSubNav: function() {
        var MM = ACC.mobilemenu;
        var c = MM._constants;
        var $this = $(this);
        var trackId = $this.attr(c.DATA_CATEGORY_ID);
        var mobileId = `m-${trackId}`;
        var closestTreeSubNavContainer, categoryNode;

        closestTreeSubNavContainer = $this.closest(c.SELECTOR_TREE_SUB_NAVIGATION_CONTAINER);
        categoryNode = closestTreeSubNavContainer.find('.' + trackId);
        $this.append(categoryNode);
        closestTreeSubNavContainer.find('.' + trackId).removeAttr('id').wrap(`<div id="${mobileId}" class="level-2-navigation-container"></div>`);

        $this.children('a.name, button.name').attr('aria-controls', mobileId);

        $this.children('a.name, button.name').on('click touch', function (e) {
            var target = $(e.target);
            var isSecondLevelNode = (target.closest(c.SELECTOR_LEVEL_2).length) ? true : false;

            if (!isSecondLevelNode) {
                var secondLevelNavContainer = target.closest(c.SELECTOR_LEVEL_1).find(c.SELECTOR_LEVEL_2_NAV_CONTAINER);
                var arrow = target.closest(c.SELECTOR_LEVEL_1).find(c.SELECTOR_ARROW_ICON);
                var secondLevelNodes = $(secondLevelNavContainer).find('li.level_2');

                e.preventDefault();
                e.stopPropagation();

                // Analytics
                secondLevelNodes.on('click touch', function(event) {
                    ACC.megamenu.attachMegaMenu_L2(event, $(this));
                });

                if (secondLevelNavContainer.is(':hidden')) {
                    // Expand
                    target.addClass(c.CLASS_FONT_BOLD);
                    target.attr('aria-expanded', 'true');
                    arrow.removeClass(c.CLASS_ICON_DOWN).addClass(c.CLASS_ICON_UP);
                    secondLevelNavContainer.slideDown();
                } else {
                    // Collapse
                    target.removeClass(c.CLASS_FONT_BOLD);
                    target.attr('aria-expanded', 'false');
                    arrow.removeClass(c.CLASS_ICON_UP).addClass(c.CLASS_ICON_DOWN);
                    secondLevelNavContainer.slideUp();
                }
            }
        });
    },

    // Add any bindings to menu elements here.
    bindMobileMenuEvents: function() {
        var MM = ACC.mobilemenu;
        var cache = MM._cache;
        var SP = ACC.sidepanel;
        var SP_s = SP._state;

        // Menu openers.
        cache.$menuButton.on('click', function() {
            const firstBurgerMenuItem = $('.sidepanel .tree-navigation-wrapper .tree-navigation a')[0];
            SP.open(cache.$component,'noAnimation');
            if (!SP_s.IS_TREE_NAVIGATION) {
                $('h3.o-default-menu-nav-bold').html($(this).attr('data-menuTitle'));
            }
            firstBurgerMenuItem.focus();
        });

        // Update back button after view update.
        cache.$component.on('view_update', function() {
            MM.setBackText();
        });

        // Reset on resize to compensate for mobile > desktop sizes (e.g. on rotate).
        $(window).on('resize', function() {
            MM.adjustHeights();
        });
    },

    // On search input main navigation categories need to hide.
    // When search cleared, they need to show.
    bindMobileSearchAutocomplete: function() {
        var MM = ACC.mobilemenu;
        var cache = MM._cache;
        var c = MM._constants;

        $(document).on('ACC.autocomplete.open', function() {
            cache.$component.addClass(c.CLASS_SEARCH_ACTIVE);
        });

        $(document).on('ACC.autocomplete.close', function() {
            cache.$component.removeClass(c.CLASS_SEARCH_ACTIVE);
        });
    },

    applyMobileColors: function() {
        const MM = ACC.mobilemenu;
        const c = MM._constants;
        const $nodes = $(`#mobileMenu li[${c.DATA_CATEGORY_TEXT_COLOR}], li[${c.DATA_CATEGORY_BACKGROUND_COLOR}]`);
    
        $nodes.each(function() {
            const $node = $(this);
            const textColor = $node.attr(c.DATA_CATEGORY_TEXT_COLOR);
            const backgroundColor = $node.attr(c.DATA_CATEGORY_BACKGROUND_COLOR);
    
            if (textColor) {
                $node.children('a[href], button').each(function() {
                    this.style.setProperty('color', textColor.trim());
                });
    
                $node.children('.icon-container').each(function() {
                    this.style.setProperty('color', textColor.trim()); 
                    $(this).find('.icon').each(function() {
                        this.style.setProperty('color', textColor.trim()); 
                    });
                });
            }
    
            if (backgroundColor) {
                $node.children('a[href], button').each(function() {
                    this.style.setProperty('background-color', backgroundColor.trim());
                });
            }
        });
    },

    // Set the main title element within the component content.
    // @text (String) Text to add.
    setBackText: function() {
        var MM = ACC.mobilemenu;
        var cache = MM._cache;
        var SP = ACC.sidepanel;
        var SP_c = SP._constants;
        var $text = cache.$component.data(SP_c.DATA_BACK).find('.' + SP_c.CLASS_BACK_TEXT);
        var $previous = SP.getPreviousPanel(cache.$component);
        var text = $previous.length ? $previous.attr(SP_c.ATTRIBUTE_PANEL_TITLE) : '';

        // Not good to do visual design stuff here but, first a little case adjustment.
        text = cache.text.back + text;
        if ($text && $text.length) {
            $text.text(text);
        }
    },

    adjustHeights: function() {
        var MM = ACC.mobilemenu;
        var cache = MM._cache;
        var cookieMessageHeight = ACC.cookie.getAreaOpenMessageHeight();
        var searchContainerHeight = cache.$search.outerHeight(true);

        // Calculate and apply correct (100% - search area) height to navigation element.
        cache.$nav.css('height', window.innerHeight - (cookieMessageHeight + searchContainerHeight) + 'px');
    },

    // Any custom needed to be added to shared side panel open.
    open: function() {
        if (!SP_s.IS_TREE_NAVIGATION) {
            ACC.mobilemenu.adjustHeights();
        }
    },

    // Any custom needed to be added to menu side panel close action.
    close: function() {
        ACC.autocomplete.mobileSearchClose();
    },

    // Opens the menu area at a given point.
    // @section (String) data-categoryid value for jumping to that point.
    openAt: function(id) {
        var MM = ACC.mobilemenu;
        var cache = MM._cache;
        var SP = ACC.sidepanel;
        var path;

        // Reset then build journey through path.
        SP.intialiseState(cache.$component);
        cache.$panels.each(function() {
            if (this.getAttribute(SP._constants.ATTRIBUTE_PANEL_ID) === id) {
                // Instant update the view with each path categoryid.
                path = this.getAttribute(SP._constants.ATTRIBUTE_PANEL_PATH).split('|');
                for (var i=0; i<path.length; ++i) {
                    SP.updateView(cache.$component, path[i]);
                }
                return true;
            }
        });

        SP.open(cache.$component);
    }
};
